import { useCallback } from "react";
import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import { yup } from "utils";

import { useCountries } from "hooks";

const billingSchema = yup.object({
  firstName: yup.string().required("Missing First Name"),
  lastName: yup.string().required("Missing Last Name"),
  address: yup.string().required("Missing Address"),
  city: yup.string().required("Missing City"),
  zipCode: yup.string().required("Missing Zip / Postal Code"),
  country: yup
    .object()
    .nullable()
    .test((v, ctx) => {
      return (
        Boolean(v?.code) || ctx.createError({ message: "Missing Country" })
      );
    }),
});

export function useBillingForm(user) {
  const countries = useCountries();

  const initialValues = {
    firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    address: "",
    city: "",
    country: countries.byCode.get("US"),
    zipCode: "",
  };

  const { setError: setFieldError, ...formProps } = useForm({
    resolver: yupResolver(billingSchema),
    mode: "onSubmit",
    defaultValues: initialValues,
    criteriaMode: "all",
  });

  const setError = (e) => {
    const resolveInputName = (m = "") => {
      if (m.includes("zip")) return "zipCode";
      else if (m.includes("address")) return "address";
      else if (m.includes("country")) return "country";
      else if (m.includes("city")) return "city";
      return "";
    };

    const inputName = resolveInputName(e?.message?.toLowerCase());

    if (inputName) {
      setFieldError(
        inputName,
        { type: "custom", message: e.message },
        { shouldFocus: true }
      );
    }

    return inputName;
  };

  return {
    formProps: formProps,
    setError: useCallback(setError, [setFieldError]),
  };
}

export default useBillingForm;
